import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	max-height: 59vh;

	display: flex;
	flex-direction: column;

	padding-left: 60px;
	padding-right: 30px;
	padding-bottom: 15px;

	> button {
		align-self: end;
	}
`;

export const ContentContainer = styled.div`
	padding: 0 0 15px 30px;

	height: 70vh;
	overflow-y: auto;

	@media (max-height: 900px) {
		height: 52vh;
	}
`;

export const EmptyContainer = styled.div`
	display: flex;

	padding: 40px 0 15px 0;
	gap: 5vw;
`;

export const CommunicationsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 40px 0 20px 0;
	gap: 5vw;

	@media (max-width: 1600px) {
		gap: 2vw;
	}
`;

export const SpinnerContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40vh;
`;

export const SubtitleEmpty = styled.h3`
	font-size: 16px;
	font-weight: 600;
	margin: 64px 0;
	color: ${tokens.color_gray_dark};
`;
